import { CLOSE_LOGIN_MODAL, OPEN_LOGIN_MODAL, RESET_AUTH, SET_AUTHENTICATED, SET_AUTH_ERROR, SET_AUTH_LOADING, SET_AUTH_STEP, SET_OTP, SET_PENDING_ROOM, SET_PHONE_NUMBER, SET_USERNAME, SET_USER_INFO } from './actionTypes';
export function setAuthStep(step) {
    return {
        type: SET_AUTH_STEP,
        step
    };
}
export function setPhoneNumber(phoneNumber) {
    return {
        type: SET_PHONE_NUMBER,
        phoneNumber
    };
}
export function setOtp(otp) {
    return {
        type: SET_OTP,
        otp
    };
}
export function setUsername(username) {
    return {
        type: SET_USERNAME,
        username
    };
}
export function setAuthLoading(loading) {
    return {
        type: SET_AUTH_LOADING,
        loading
    };
}
export function setAuthError(error) {
    return {
        type: SET_AUTH_ERROR,
        error
    };
}
export function setAuthenticated(isAuthenticated) {
    return {
        type: SET_AUTHENTICATED,
        isAuthenticated
    };
}
export function setUserInfo(userInfo) {
    return {
        type: SET_USER_INFO,
        userInfo
    };
}
export function resetAuth() {
    return {
        type: RESET_AUTH
    };
}
export function openLoginModal(pendingRoom) {
    return {
        type: OPEN_LOGIN_MODAL,
        pendingRoom: pendingRoom || null
    };
}
export function closeLoginModal() {
    return {
        type: CLOSE_LOGIN_MODAL
    };
}
export function setPendingRoom(room) {
    return {
        type: SET_PENDING_ROOM,
        room
    };
}
export function logout() {
    return {
        type: RESET_AUTH
    };
}
